import dynamic from 'next/dynamic';
export const HeaderBanner = dynamic(() => import('./header-banner'));